import { CrudApi } from './CrudApi';
import { SubscriptionPlanModel } from '../models/subscriptionPlan/SubscriptionPlanModel';

class SubscriptionPlanApi extends CrudApi<SubscriptionPlanModel>{
	constructor() {
		super('subscription-plan', (obj) => new SubscriptionPlanModel().load(obj));
	}
}
export const subscriptionPlanApi = new SubscriptionPlanApi();